import { render, staticRenderFns } from "./holders.vue?vue&type=template&id=58cff494"
import script from "./holders.vue?vue&type=script&lang=js"
export * from "./holders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports